export default "__VITE_ASSET__f0Ve0g6G__"